import React, { Component } from "react";
import Aux from "../../../../hoc/Auxilliary";
import { getCountries, createCountry, updateCountry, deleteCountry } from "../../../../data-service-admin";
import { ToastContainer } from "react-toastr";
import DeleteModal from "../Common/DeleteModal";
import AddEditModal from "../Common/AddEditModal";
import { showSuccessToastMessage, showErrorToastMessage } from "../../../../utilities";
import Grid from "../Common/Grid";
import Spinner from "../../../User/Common/Spinner/Spinner";
import Search from "../Common/Search";
import { emptyCheck } from "../../../../utilities";
import AdminBreadcrumb from "../Common/Breadcrumb";
import RequiredField from "../Common/RequiredField";

class AdminCountries extends Component {
  state = {
    mastercountries: [],
    countries: [],
    selectedCountry: {},
    showModal: false,
    modalTitle: "",
    showDeleteModal: false,
    modalDeleteTitle: "",
    modalDeleteMessage: "",
    action: "edit",
    showSpinner: false,
    searchTerm: "",
    errorMessage: ""
  };
  componentDidMount() {
    this.getCountriesFromService();
  }
  showSpinner(isShow) {
    this.setState({
      showSpinner: isShow
    });
  }
  getCountriesFromService() {
    this.showSpinner(true);
    getCountries()
      .then(response => {
        this.setState({ countries: response.data, mastercountries: response.data });
        this.showSpinner(false);
      })
      .catch(error => {
        this.showSpinner(false);
        console.log(error);
        this.showErrorMessage(error);
      });
  }

  editCountry(country) {
    this.setState({
      action: "edit",
      selectedCountry: country,
      showModal: true,
      errorMessage: ""
    });
  }

  deleteCountry(country) {
    this.setState({
      action: "delete",
      selectedCountry: country,
      showDeleteModal: true
    });
  }

  addCountry() {
    this.setState({
      action: "add",
      selectedCountry: {},
      showModal: true,
      errorMessage: ""
    });
  }
  onHideModal() {
    this.setState({
      showModal: false
    });
  }

  onHideDeleteModal() {
    this.setState({
      showDeleteModal: false
    });
  }
  showSuccessMessage(item) {
    showSuccessToastMessage(this, "toastr1", this.state.action, item, "Country");
  }
  showErrorMessage(error) {
    showErrorToastMessage(this, "toastr1", error);
  }

  validate(data) {
    if (emptyCheck(data.Name)) {
      this.setState({ errorMessage: "Name cannot be blank" });
      return false;
    }
    return true;
  }

  saveCountry() {
    const data = {
      Id: this.state.action === "edit" ? this.state.selectedCountry.Id : 0,
      Name: this.refs["txtCountry"].value
    };
    if (this.validate(data)) {
      switch (this.state.action) {
        case "add":
          this.showSpinner(true);
          createCountry(data)
            .then(response => {
              this.showSpinner(false);
              console.log(response);
              this.onHideModal();
              this.showSuccessMessage(data.Name);
              this.getCountriesFromService();
            })
            .catch(error => {
              this.showSpinner(false);
              console.log(error);
              this.showErrorMessage(error);
              this.onHideModal();
            });
          break;
        case "edit":
          this.showSpinner(true);
          updateCountry(data)
            .then(response => {
              this.showSpinner(false);
              console.log(response);
              this.onHideModal();
              this.showSuccessMessage(data.Name);
              this.getCountriesFromService();
            })
            .catch(error => {
              this.showSpinner(false);
              console.log(error);
              this.showErrorMessage(error);
              this.onHideModal();
            });
          break;
        default:
          break;
      }
    }
  }
  confirmDeleteCountry() {
    this.showSpinner(true);
    deleteCountry(this.state.selectedCountry.Id)
      .then(response => {
        this.showSpinner(false);
        console.log(response);
        this.onHideDeleteModal();
        this.showSuccessMessage(this.state.selectedCountry.Name);
        this.getCountriesFromService();
      })
      .catch(error => {
        this.showSpinner(false);
        console.log(error.response);
        this.showErrorMessage(error);
        this.onHideDeleteModal();
      });
  }
  handleCountryChange = event => {
    let selectedCountry = this.state.selectedCountry;
    selectedCountry.Name = event.target.value;
    this.setState({ selectedCountry: selectedCountry });
  };

  manageStates(country) {
    this.props.history.push(`/admin/states/` + country.Id);
  }

  handleSearchTermChange = event => {
    let filteredCountries = this.state.mastercountries.filter(d => {
      const name = String(d.Name).toLowerCase();
      return name.indexOf(event.target.value) > -1;
    });
    if (event.target.value)
      this.setState({
        countries: filteredCountries,
        searchTerm: event.target.value
      });
    else
      this.setState({
        countries: this.state.mastercountries,
        searchTerm: event.target.value
      });
  };

  render() {
    return (
      <Aux>
        <ToastContainer ref="toastr1" className="toast-top-right" />
        <Spinner showSpinner={this.state.showSpinner} />
        <h1 className="page-header">Countries</h1>
        <AdminBreadcrumb data={[{ name: "Home", link: "/admin/modules/" }, { name: "Countries" }]} />
        <button className="btn btn-default add-btn" onClick={() => this.addCountry()}>
          Add Country
        </button>

        <Search searchTerm={this.state.searchTerm} handleSearchTermChange={this.handleSearchTermChange.bind(this)} />
        <Grid
          headers={["#", "Name"]}
          values={this.state.countries}
          indexName="Id"
          properties={["Id", "Name", "Action"]}
          edit={value => this.editCountry(value)}
          delete={value => this.deleteCountry(value)}
          extraActions={[value => this.manageStates(value)]}
          extraActionNames={["Manage States"]}
        />
        <AddEditModal
          showModal={this.state.showModal}
          onHideModal={() => this.onHideModal()}
          modalTitle={this.state.modalTitle}
          save={() => this.saveCountry()}
          form={this.addeditform}
          type="country"
          action={this.state.action}
          errorMessage={this.state.errorMessage}
        >
          <div className="form-group">
            <label>
              <RequiredField />
              Name:
            </label>
            <input
              minLength="3"
              maxLength="50"
              type="text"
              className="form-control"
              ref="txtCountry"
              defaultValue={this.state.selectedCountry.Name}
            />
          </div>
        </AddEditModal>
        <DeleteModal
          key={this.state.selectedCountry.Id}
          showModal={this.state.showDeleteModal}
          onHideModal={() => this.onHideDeleteModal()}
          confirm={() => this.confirmDeleteCountry()}
          name={this.state.selectedCountry.Name}
          type="country"
        />
      </Aux>
    );
  }
}

export default AdminCountries;



// WEBPACK FOOTER //
// ./src/containers/Admin/AdminMainContent/Countries/Countries.js